var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#137CFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.58 19.9999C23.58 21.9799 21.98 23.5799 20 23.5799C18.02 23.5799 16.42 21.9799 16.42 19.9999C16.42 18.0199 18.02 16.4199 20 16.4199C21.98 16.4199 23.58 18.0199 23.58 19.9999Z",
    stroke: "#137CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.27C23.53 28.27 26.82 26.19 29.11 22.59C30.01 21.18 30.01 18.81 29.11 17.4C26.82 13.8 23.53 11.72 20 11.72C16.47 11.72 13.18 13.8 10.89 17.4C9.99 18.81 9.99 21.18 10.89 22.59C13.18 26.19 16.47 28.27 20 28.27Z",
    stroke: "#137CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.31373ffc68cf79168141662ee0073b8d.svg";
export { ForwardRef as ReactComponent };